<a class="nav-listing flex-grow-1"
    [routerLink]="
        navigation().disabled ? undefined : (
            isCompany() ? getCompanyChildUrl(navigation().url ?? []) : navigation().url
        )
    "
    [routerLinkActive]="['active','bg--accent-primary-10', 'color--accent-primary', 'shadow-small-inset']"
    [class]="{
        'nav-listing-disabled': navigation().disabled
    }"
>
    <span class="nav-listing-text font-light">{{navigation().name}}</span>
    
    @if(navigation().disabled){
        <div class="nav-listing-icon color--red-400">
            <fa-icon [icon]="['far', 'circle-xmark']"/>
        </div>
    }
    @else if(navigation().url){
        <div class="nav-listing-icon enter-icon color--accent-primary">
            <fa-icon [icon]="['far', 'arrow-right-to-arc']"/>
        </div>
    }

</a>